import {BaseEntity} from "./BaseEntity";

export class SensorStat implements BaseEntity {
    constructor(
        public id?:number,
        public vTagID?:string,
        public created?:Date,
        public sourceDistanceHops?:string,
        public ttl?:number,
        public numNeighbors?:number,
        public numActiveNeighbors?:number,
        public totalErrors?:number,
        public lastError?:number,
        public bestNeighbor?:string,
        public bestNeighborRssiDbm?:number,
        public minQueue?:number,
        public maxQueue?:number,
        public avgQueue?:number,
        public processedPackets?:number,
        public alarmCount?:number,
        public firmwareVersion?:number,
        public movementTriggers?:number,
        public suspectTriggers?:string,
        public daysSinceReset?:number,
        public leafDroppedPackets?:number){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.vTagID = json.vTagID;
        this.created = json.created;// == null ? "" :  moment(json.created).format(entities.ApplicationSetting.applicationSetting.dateFormat);
        this.sourceDistanceHops = json.sourceDistanceHops;
        this.ttl = json.ttl;
        this.numNeighbors = json.numNeighbors;
        this.numActiveNeighbors = json.numActiveNeighbors;
        this.totalErrors = json.totalErrors;
        this.lastError = json.lastError;
        this.bestNeighbor = json.bestNeighbor;
        this.bestNeighborRssiDbm = json.bestNeighborRssiDbm;
        this.minQueue = json.minQueue;
        this.maxQueue = json.maxQueue;
        this.avgQueue = json.avgQueue;
        this.processedPackets = json.processedPackets;
        this.alarmCount = json.alarmCount;
        this.firmwareVersion = json.firmwareVersion;
        this.movementTriggers = json.movementTriggers;
        this.suspectTriggers = json.suspectTriggers;
        this.daysSinceReset = json.daysSinceReset != null ? json.daysSinceReset.toFixed(1) : null;
        this.leafDroppedPackets = json.leafDroppedPackets
    }
}
